module.exports = __webpack_public_path__ + "static/media/logo-vw@2x.480af5d0.jpg";